import axios from 'axios'
import router from "../router/index.js";

import {baseUrl} from "./baseUrl.js";

// Automatically prepend to URL
axios.defaults.baseURL = baseUrl
// Timeout
axios.defaults.timeout = 30000
// Cross-origin credentials
axios.defaults.withCredentials = false

axios.interceptors.request.use(config => {
    const token = localStorage.getItem("token")
    // if (!token) {
    //     router.push("/user/login")
    // }
    config.headers["Authorization"] = "Token " + token
    return config
}, error => {
    return Promise.reject(error)
})
axios.interceptors.response.use(res => {
    return res.data
}, error => {
    if (error.response.status === 401) {
        console.log(router.currentRoute, "route")
        router.push({path: "/user/login", query: {redirect: router.currentRoute.value.fullPath}})
    }
    return Promise.reject(error)
})
// Response and request interceptor configuration
export default axios
